import { BaseEntityListComponent } from './../base-entity-list.component';
import { CouponDialogComponent } from './../coupon-dialog/coupon-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Coupon } from './../coupon.model';
import { CouponService } from './../coupon.service';
import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-coupons',
  templateUrl: './coupons.component.html',
  styleUrls: ['./coupons.component.css']
})
export class CouponsComponent extends BaseEntityListComponent<Coupon> {

  displayedColumns = ["code", "type", "value", "expire", "notes", "limit", "enabled", "actions"];

  constructor(private couponService: CouponService, private dialog: MatDialog, private snackBar: MatSnackBar, ) {
    super(Coupon, couponService, snackBar);
  }

  edit(coupon: Coupon) {

    const dialogRef = this.dialog.open(CouponDialogComponent, {
      width: '50%',
      data: coupon
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        if (result.code) {
          result.code = result.code.toUpperCase();
        }
        this.save(result);
      }
    });
  }

}
